import { useMemo } from 'react';
import type { AuthTokenStatus } from '@lingoda/monolith-graphql';
import { getApolloErrorUiMessage, useCalendarListQuery } from '@lingoda/monolith-graphql';
import { isAnyCalendarConnected } from '@lingoda/calendar-connection/logic/wasAnyCalendarEverConnected';
import { trans } from '@lingoda/i18n';
import { showErrorToast } from '@lingoda/toasts';

export const useShouldShowConnectYourCalendar = () => {
    const { data } = useCalendarListQuery({
        onError(error) {
            showErrorToast(getApolloErrorUiMessage(error) || trans('masked-error', {}, 'errors'));
        },
    });

    const { shouldShowConnectYourCalendar } = useMemo(() => {
        const calendars = data?.calendarList || [];

        return {
            shouldShowConnectYourCalendar: shouldShowConnectCalendar(
                calendars.map(({ status }) => status),
            ),
        };
    }, [data?.calendarList]);

    return {
        shouldShowConnectYourCalendar,
    };
};

const shouldShowConnectCalendar = (calendarStatuses: (AuthTokenStatus | null)[]) => {
    return !!calendarStatuses.length && !isAnyCalendarConnected(calendarStatuses);
};
